import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { QrCode, ArrowLeft } from "@phosphor-icons/react";
import { useLang } from "../context/LangContext";
import { Footer } from "../components/Footer";

export default function Legal() {
  const { type } = useParams();
  const { t, lang, toggle } = useLang();
  const key = ["privacy", "terms", "cookie"].includes(type) ? type : "privacy";
  const page = t.legalPages[key];

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid={`legal-page-${key}`}>
      <header className="border-b border-slate-200">
        <div className="mx-auto max-w-3xl px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-logo">
            <div className="flex h-8 w-8 items-center justify-center bg-[#0A0F1A] rounded-[4px]"><QrCode size={18} weight="bold" className="text-white" /></div>
            <span className="font-display font-bold text-[17px] tracking-tight">Certifico<span className="text-emerald-500">QR</span></span>
          </Link>
          <button onClick={toggle} className="font-mono-tech text-xs font-semibold border border-slate-300 rounded-[4px] px-2 py-1" data-testid="legal-lang-toggle">{lang.toUpperCase()}</button>
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-3xl px-6 py-14">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}>
          <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-emerald-600">Certifico QR</p>
          <h1 className="mt-3 font-display font-bold text-3xl sm:text-4xl tracking-tight text-[#0F172A]" data-testid="legal-title">{page.title}</h1>
          <p className="mt-2 text-sm text-slate-500">{t.legalPages.updated}</p>

          <div className="mt-10 space-y-8">
            {page.sections.map((s) => (
              <section key={s.h}>
                <h2 className="font-display font-bold text-lg text-[#0F172A]">{s.h}</h2>
                <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{s.p}</p>
              </section>
            ))}
          </div>

          <Link to="/" className="mt-12 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A] transition-colors" data-testid="legal-back">
            <ArrowLeft size={16} /> {t.legalPages.back}
          </Link>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
